import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FirebaseAuthService } from '../../providers/firebase-auth.service';
import { UploadFileService } from '../../providers/upload-file.service';
import { UPLOAD_STATUS } from 'src/app/models/groupedCard';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-renderlimit-select',
  templateUrl: './renderlimit-select.component.html',
  styleUrls: ['./renderlimit-select.component.scss'],
  animations: [
    trigger('tooltip', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class RenderlimitSelectComponent implements OnInit {
  @Input() inputMaxElementsInRow: number = 5;
  @Input() isRenderLimitTitleShown: boolean = false;
  @Input() isLoggedIn: boolean = false;
  @Input() tooltipEnabled: boolean = false;
  @Output() renderLimitChange = new EventEmitter<number>();
  renderLimitOptions = [10, 25, 50, 100, 9999]; // Standard options
  selectedRenderLimit: number = 25; // Default to 25
  public isMobile: boolean = environment.type === 'mobile';
  tooltipMessages: { [key: number]: string } = {
    10: 'A great choice for starters!',
    25: 'Perfect for frequent users!',
    50: 'For the power users!',
    100: 'Unleash your creativity!',
    9999: 'No limits, no notifications!',
  };
  currentTooltip: string = '';
  private tooltipTimeout: any;

  constructor(
    public firebaseAuth: FirebaseAuthService,
    public uploadService: UploadFileService
  ) {}

  ngOnInit(): void {
    // Check if user is logged in by checking if currentUser exists
    const userIsLoggedIn = this.isLoggedIn || this.firebaseAuth.currentUser;

    if (userIsLoggedIn) {
      // Subscribe to the service to get the current render limit
      if (this.firebaseAuth.currentUser?.renderLimit !== undefined) {
        this.selectedRenderLimit = this.firebaseAuth.currentUser.renderLimit;
      }
      // You may also subscribe to changes in currentUser if needed
      this.firebaseAuth.firebaseUser.subscribe(user => {
        if (this.firebaseAuth.currentUser?.renderLimit !== undefined) {
          this.selectedRenderLimit = this.firebaseAuth.currentUser.renderLimit;
        }
      });
    }
  }

  getCurrentUploadingCards() {
    const userIsLoggedIn = this.isLoggedIn || this.firebaseAuth.currentUser;

    if (!userIsLoggedIn) {
      return 0;
    }
    return this.uploadService.uploadModels.filter((groupedCard) => {return groupedCard.uploadStatus.status === UPLOAD_STATUS.INPROGRESS || groupedCard.uploadStatus.status === UPLOAD_STATUS.PROCESSING})?.length;
  }

  setRenderLimit(limit: number) {
    const userIsLoggedIn = this.isLoggedIn || this.firebaseAuth.currentUser;

    if (!userIsLoggedIn) {
      this.selectedRenderLimit = limit;
      if (this.tooltipEnabled) {
        this.currentTooltip = this.tooltipMessages[limit];
        this.resetTooltipTimeout();
      }
      return;
    }
    if (limit === 9999 || limit >= this.firebaseAuth.currentUser.renderModelsPerCycle) {
      this.selectedRenderLimit = limit;
      this.renderLimitChange.emit(limit);
      if (this.tooltipEnabled) {
        this.currentTooltip = this.tooltipMessages[limit];
        this.resetTooltipTimeout();
      }
    }
  }

  resetTooltipTimeout() {
    clearTimeout(this.tooltipTimeout);
    this.tooltipTimeout = setTimeout(() => {
      this.currentTooltip = '';
    }, 2000);
  }

  isSelected(limit: number) {
    return this.selectedRenderLimit === limit;
  }

}
